import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import withAuth from "../../components/withAuth";

// STATE AND STORE
// LIBS
import API from "../../api";
import { getDateFormat } from "../../lib/helpers/dates";
import { sortFilialPercentsOnPriority } from "../../lib/helpers/sort";
import {} from "../../lib/helpers/filials";
import { getDayLabelNumber } from "../../lib/helpers/wordForm";
import {
  sumFormat,
  suffixMoney,
  suffixPercent,
  suffixCount
} from "../../lib/helpers/strings";

// UI
import { Box, Header, HeaderPage, P, Button, Row, Col, HR } from "../../ui";
// COMPONENTS
import FilialPercents from "./components/percents";
import FilialPrices from "./components/prices";
import FilialMoney from "./components/money";

class FilialOnePage extends Component {
  state = {
    loading: true,
    titleHeader: "Филиал",
    filial: {}
  };

  async componentDidMount() {
    const { id } = this.props.match.params;
    const filial = await API.filials.getOne(id);

    // Сортировка процентов по приоритету
    if (filial && filial.percents_list && filial.percents_list.length) {
      filial.percents_list.sort(sortFilialPercentsOnPriority);
    }

    let titleHeader = `${filial.name} - ${this.state.titleHeader}`;

    this.setState({ loading: false, filial, titleHeader });
  }

  render() {
    const { id } = this.props.match.params;
    const { filial } = this.state;
    let prices =
      filial &&
      filial.prices_id &&
      filial.prices_id.prices &&
      filial.prices_id.prices.length
        ? filial.prices_id.prices
        : [];

    if (filial && filial.name) {
      return (
        <div className="short">
          <Helmet>
            <title>{this.state.titleHeader}</title>
          </Helmet>

          <HeaderPage
            preBeforeTitle={this.state.titleHeader}
            title={filial.name}
            postSubTitle={`Создан: ${getDateFormat(
              filial.created_at
            )} | Изменён: ${getDateFormat(filial.updated_at)}`}
            back={this.props.history.goBack}
          >
            {/* <ButtonGroup>
              <Button type="as" as={Link} to={`/filials/${id}/edit`}>Изменить филиал</Button>
            </ButtonGroup> */}
          </HeaderPage>

          <Box>
            <Row withMain={true}>
              <Col padding="no" main={true}>
                <Header size={2} margin="no-top">
                  Информация
                </Header>
              </Col>
              <Col padding="no" normal={true}>
                {filial.percents_list && filial.percents_list.length ? (
                  <Button
                    size="s"
                    type="as"
                    as={Link}
                    to={`/filials/${id}/edit`}
                  >
                    Изменить информацию
                  </Button>
                ) : null}
              </Col>
            </Row>

            <Row>
              <Col padding="no-top-left">
                <Header size={5} margin="no-top">
                  Главное
                </Header>

                <Header size={6} margin="no-bottom">
                  Название:
                </Header>
                <P slim={true}>{filial.name}</P>

                <Header size={6} margin="no-bottom">
                  Местоположение:
                </Header>
                <P slim={true}>{filial.city}</P>

                <Header size={6} margin="no-bottom">
                  Рабочие дни:
                </Header>
                <P slim={true}>{filial.work_days}</P>
              </Col>

              <Col padding="no-top-left">
                <Header size={5} margin="no-top">
                  Касса
                </Header>

                <Header size={6} margin="no-bottom">
                  Начало дня:
                </Header>
                <P slim={true}>
                  {sumFormat(filial.cash_desk_start_day, suffixMoney)}
                </P>

                <Header size={6} margin="no-bottom">
                  Конец дня:
                </Header>
                <P slim={true}>{sumFormat(filial.cash_desk, suffixMoney)}</P>
              </Col>

              <Col padding="no-top">
                <Header size={5} margin="no-top">
                  Количество
                </Header>

                <Header size={6} margin="no-bottom">
                  Залоговых билетов:
                </Header>
                <P slim={true}>{sumFormat(filial.count_bilets, suffixCount)}</P>

                <Header size={6} margin="no-bottom">
                  Приходных ордеров:
                </Header>
                <P slim={true}>
                  {sumFormat(filial.count_blanks_add, suffixCount)}
                </P>

                <Header size={6} margin="no-bottom">
                  Расходных ордеров:
                </Header>
                <P slim={true}>
                  {sumFormat(filial.count_blanks_remove, suffixCount)}
                </P>
              </Col>

              <Col padding="no-top">
                <Header size={5} margin="no-top">
                  Прочее
                </Header>

                <Header size={6} margin="no-bottom">
                  Количество дней штрафа:
                </Header>
                <P slim={true}>{getDayLabelNumber(filial.count_fine_days)}</P>

                <Header size={6} margin="no-bottom">
                  Процент штрафа за задержку:
                </Header>
                <P slim={true}>
                  {sumFormat(filial.percent_fine, suffixPercent)}
                </P>

                <Header size={6} margin="no-bottom">
                  Штраф за потерю билета:
                </Header>
                <P slim={true}>
                  {sumFormat(filial.sum_fine_bilet_out, suffixMoney)}
                </P>
              </Col>
            </Row>

            <HR mutted theme={"dashed"} />

            <FilialPercents
              filialId={id}
              loading={this.state.loading}
              percentsList={filial.percents_list || []}
            />

            <HR mutted theme={"dashed"} />

            <FilialPrices
              filialId={id}
              loading={this.state.loading}
              prices={prices}
            />

            <HR mutted theme={"dashed"} />

            <FilialMoney filialId={id} />

            {/*
            <HR mutted theme={"dashed"} />

            <Header size={4}>Пользователи</Header>

            <HR mutted theme={"dashed"} />

            <Header size={4}>Материальная ведомость</Header>
            */}
          </Box>
        </div>
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = state => ({});

export default connect(mapStateToProps)(withAuth(FilialOnePage));
